export default "__VITE_ASSET__CqpsBq88__"